import { create } from 'zustand';

import {
	DEFAULT_MOBILE_PLATFORM,
	MobilePlatform
} from 'src/apps/dashboard/constants/MobileDashboard.constants';

interface IMobileDashboardFiltersStore {
	platform: MobilePlatform;
	appIds: string[];
	businessUnitId: string | null;
	setPlatform: (platform: MobilePlatform) => void;
	setAppIds: (appIds: string[]) => void;
	setBusinessUnitId: (businessUnitId: string | null) => void;
	resetMobileFilters: () => void;
}

export const useMobileDashboardFiltersStore = create<IMobileDashboardFiltersStore>((set) => ({
	platform: DEFAULT_MOBILE_PLATFORM,
	appIds: [],
	businessUnitId: null,
	setPlatform: (platform) => set({ platform }),
	setAppIds: (appIds) => set({ appIds }),
	setBusinessUnitId: (businessUnitId) => set({ businessUnitId }),
	resetMobileFilters: () =>
		set({
			platform: DEFAULT_MOBILE_PLATFORM,
			appIds: [],
			businessUnitId: null
		})
}));
